import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Screen } from "../../../main/components/screen/Screen";
import { alarmsApi } from "../../../services/api";
import { AlarmDetails, SeverityTypesEnum } from "../types";
import EmptyStateNotFound from "../../clients/components/EmptyState";
import Loading from "../../../main/components/Loading";
import { AlarmConsult } from "../components/AlarmConsult";
import { CardAccordions } from "../components/AlarmCardAccordions";
import AlarmDetailsEditContent from "../components/AlarmDetailsEditContent";

export default function AlarmsConsultComponent() {
  const [loading, setLoading] = useState<boolean>(true);
  const [alarmDetails, setAlarmDetails] = useState<AlarmDetails | null>(null);
  const path = window.location.pathname;
  const alarmCode = path.split("/")[3];

  async function updateDetails() {
    setLoading(true);
    try {
      const alarmDetailsResponse = await alarmsApi.getAlarmDetails(alarmCode);
      setAlarmDetails(alarmDetailsResponse);
    } catch (error) {
      throw new Error("Erro ao carregar detalhes do alarme");
    } finally {
      setLoading(false);
    }
  }

  const onMount = async () => {
    await updateDetails();
  };

  useEffect(() => {
    onMount();
  }, []);

  return (
    <Screen.Root>
      {loading ? (
        <>
          <Screen.Container>
            <Loading />
          </Screen.Container>
        </>
      ) : alarmDetails || true ? (
        <>
          <Screen.Header>
            <AlarmConsult.Root>
              <AlarmConsult.Header
                alarm={alarmDetails}
                setAlarm={setAlarmDetails}
                onMount={onMount}
                text="Severidade"
                alarmSeverity={getSeverityByType(alarmDetails?.severity ?? 1)}
              />
            </AlarmConsult.Root>
          </Screen.Header>
          <Screen.Container>
            <AlarmConsult.Content title="Ações no Modo Consulta de Alarme">
              <AlarmDetailsEditContent onMount={onMount} alarm={alarmDetails} />
            </AlarmConsult.Content>
            <CardAccordions alarmDetails={alarmDetails} onMount={onMount} />
          </Screen.Container>
        </>
      ) : (
        <Screen.Container>
          <EmptyStateNotFound />
        </Screen.Container>
      )}
    </Screen.Root>
  );
}

export function getSeverityByType(type: SeverityTypesEnum) {
  switch (type) {
    case SeverityTypesEnum.bland:
      return (
        <Typography
          sx={{
            fontSize: "13px",
          }}
        >
          Brando
        </Typography>
      );
    case SeverityTypesEnum.medium:
      return (
        <Typography
          sx={{
            fontSize: "13px",
            color: "#FF9F0C",
          }}
        >
          Médio
        </Typography>
      );
    default:
      return (
        <Typography
          sx={{
            fontSize: "13px",
            color: "#FF0000",
          }}
        >
          Severo
        </Typography>
      );
  }
}
